module.exports = __webpack_public_path__ + "static/cta-aca03257dc2521dee00024da8ae2b472.jpg";